import React, { Fragment } from 'react'
import Collapse from '@material-ui/core/Collapse'
import BkFlowRoomCardNightlyRates from '../../../../room/elements/BkFlowRoomCardNightlyRates'

import _ from 'lodash'

const BkFlowSidebarRoomCardCondensed = (props) => {
	const {
		activeCurrencyData,
		arrival,
		adults,
		children,
		configData,
		currencyCode,
		currencySymbol,
		departure,
		detailsExpanded,
		displayedPriceFrequency,
		enhancementsData,
		handleDetailsAccordion,
		hotelLabels,
		nights,
		nightlyRateData,
		renderAdult,
		renderChildren,
		roomName,
		roomPrice,
		roomRatePlan,
	} = props

	return (
		<div className="bk-flow-payment__sidebar-room-card">
			{roomName && <h4>{ roomName }</h4>}
			{roomRatePlan && <p className="bk-flow-payment__sidebar-room-card__rate-name">{ roomRatePlan }</p>}

			<div
				className="bk-flow-payment__sidebar-room-card-details-btn row middle-xs"
				onClick={() => handleDetailsAccordion()}
				tabIndex={0}
			>
				<div className="bk-flow-payment__sidebar-room-card-rate-data">
					<span className="bk-flow-payment__sidebar-room-card-price">{ currencySymbol && currencySymbol }{ roomPrice }&nbsp;</span>
					<span className="bk-flow-payment__sidebar-room-card-currency">{ currencyCode && currencyCode }</span>
					<span className="bk-flow-payment__sidebar-room-card-nights">/{ displayedPriceFrequency === 'per stay' ? hotelLabels.total : hotelLabels.night }</span>
				</div>
				<div className="bk-flow-payment__sidebar-room-card-rate-toggle">
					{ hotelLabels.viewDetails ? hotelLabels.viewDetails : 'View Details' }
					<i className="material-icons">{ detailsExpanded ? 'arrow_drop_up' : 'arrow_drop_down' }</i>
				</div>
			</div>

			<Collapse
				in={ detailsExpanded }
				timeout={ 300 }
			>
				<div className="bk-flow-payment__sidebar-room-card-details">
					<p className="bk-flow-payment__sidebar-room-card-detail u-font-medium">
						<span className="u-font-bold">{ hotelLabels.arrive ? hotelLabels.arrive : 'Arrive' }</span>: { arrival }
					</p>
					<p className="bk-flow-payment__sidebar-room-card-detail u-font-medium">
						<span className="u-font-bold">{ hotelLabels.depart ? hotelLabels.depart : 'Depart' }</span>: { departure }
					</p>
					<p className="bk-flow-payment__sidebar-room-card-detail u-font-medium">
						<span className="u-font-bold">{ hotelLabels.nights ? hotelLabels.nights : 'Nights' }</span>: { nights }
					</p>
					<p className="bk-flow-payment__sidebar-room-card-detail u-font-medium">
						<span className="u-font-bold">{ hotelLabels.guests ? hotelLabels.guests : 'Guests' }: </span>
						{ adults > 0 ? renderAdult : null }
						{ children > 0 ? ', ' + renderChildren : null }
					</p>

					{ !_.isEmpty(nightlyRateData) &&
						<BkFlowRoomCardNightlyRates
							configData={configData}
							activeCurrencyData={activeCurrencyData}
							roomRateData={nightlyRateData}
							rateCurrencyCode={currencyCode}
							rateCurrencySymbol={currencySymbol}
						/>
					}

					{ !_.isEmpty(enhancementsData) &&
						<Fragment>
							<p className="bk-flow-payment__sidebar-room-card-detail u-font-medium">
								<span className="u-font-bold">
									{ hotelLabels.enhancements ? hotelLabels.enhancements : 'Enhancements' }:
								</span>
							</p>
							{ enhancementsData }
							<p className="bk-flow-payment__sidebar-room-card-services-disclaimer u-font-small">
								{ hotelLabels.additionalChargesMessage ?
									hotelLabels.additionalChargesMessage
								:
									'Each upgrade is special. A reservations specialist will reach out to customize your Betsy experience. You will not be charged for upgrades prior to arrival.'
								}
							</p>
						</Fragment>
					}
				</div>
			</Collapse>
		</div>
	)
}

export default BkFlowSidebarRoomCardCondensed


// WEBPACK FOOTER //
// ./src/components/payment/sidebar/room/layouts/BkFlowSidebarRoomCardCondensed.js